module.exports = __webpack_public_path__ + "9c8e68ccb54e9951d76c60006612303f.pdf";